export const iconFontAwesomeArrowsArrowsTurnRight = (
	<i className="fa-solid fa-arrows-turn-right"></i>
);
